import { Field, Form, FormElement } from '@progress/kendo-react-form';
import AutocompleteProject from 'commons/forms/AutocompleteProject';
import {
  FormDateTimePicker,
  FormInput,
  FormNumericTextBox,
} from 'commons/forms/form';
import { required } from 'commons/forms/validators';
import ConfirmationModal from 'commons/modal/ConfirmationModal';
import CustomModal from 'commons/modal/CustomModal';
import FormFooterWithAccess from 'commons/modal/FormFooterWithAccess';
import * as dates from 'commons/models/dates';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useLazyGetProjectQuery } from '../../../../redux/api/cache';

export default function CreateDateModal(props) {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [getProject] = useLazyGetProjectQuery();

  const handleSubmit = async (dataItem) => {
    let campseq = null;
    if (dataItem.camp !== undefined && String(dataItem.camp).includes(', #'))
      campseq = dataItem.camp?.split(', #')[1];
    else if (
      dataItem.camp !== undefined &&
      !String(dataItem.camp).includes(', #')
    )
      campseq = dataItem.camp;

    let result = await getProject({ camp_num: campseq }).unwrap();
    if (result.success && result?.data.length >= 1) {
      campseq = result.data[0].camp_seq;
    }

    props.create({
      titre: dataItem.title,
      ann_seq: props.message?.ann_seq,
      annv_dt_deb: dates.dateBdFormat(dataItem.start),
      annv_dt_fin: dates.dateBdFormat(dataItem.end),
      annv_hre_deb: dates.timeBdFormat(dataItem.start),
      annv_hre_fin: dates.timeBdFormat(dataItem.end),
      annv_proportion: dataItem.proportion,
      camp_seq: campseq,
      media_cd: props.message?.media_cd,
      nb_sem: props.message?.nbrSemaine,
      rid: props.selectedRow?.rid,
    });
    props.toggleDialog();
  };

  const dateDebutValidator = (e) => required(e, `Début`);
  const dateFinValidator = (e) => required(e, 'Fin');

  return (
    <div>
      <CustomModal
        title="Ajouter une date"
        onClose={props.toggleDialog}
        body={
          <Form
            initialValues={{
              title: props.selectedRow?.titre,
              start: dates.dateBdToDate(
                props.selectedRow?.annv_dt_deb,
                props.selectedRow?.annv_hre_deb
              ),
              end: dates.dateBdToDate(
                props.selectedRow?.annv_dt_fin,
                props.selectedRow?.annv_hre_fin
              ),
              proportion:
                props.selectedRow?.annv_proportion === undefined
                  ? null
                  : parseFloat(props.selectedRow?.annv_proportion),
              camp:
                props.selectedRow?.camp_num === undefined
                  ? ''
                  : parseFloat(props.selectedRow?.camp_num),
              nbrSemaine:
                props.selectedRow?.nb_sem === undefined
                  ? null
                  : parseFloat(props.selectedRow?.nb_sem),
            }}
            onSubmit={handleSubmit}
            render={(formRenderProps) => (
              <FormElement>
                <fieldset className={'k-form-fieldset'}>
                  <div className="row">
                    <div className="col-md-12">
                      <Field
                        disabled
                        id={'title'}
                        name={'title'}
                        label={'Titre'}
                        component={FormInput} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <Field
                        id={'start'}
                        name={'start'}
                        label={'Début'}
                        component={FormDateTimePicker}
                        validator={dateDebutValidator}
                        wrapperStyle={{
                          minWidth: '10rem'
                        }} />
                    </div>
                    <div className="col-md-4">
                      <Field
                        id={'end'}
                        name={'end'}
                        label={'Fin'}
                        component={FormDateTimePicker}
                        validator={dateFinValidator}
                        wrapperStyle={{
                          minWidth: '10rem'
                        }}></Field>
                    </div>
                    <div className="col-md-2">
                      <Field
                        disabled
                        id={'nbrSemaine'}
                        name={'nbrSemaine'}
                        label={'Nb/Sem'}
                        format={'n0'}
                        component={FormNumericTextBox}
                        wrapperStyle={{
                          minWidth: '10rem',
                        }} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <Field
                        id={'camp'}
                        name={'camp'}
                        label={'Numéro du projet'}
                        component={AutocompleteProject} />
                    </div>
                    <div className="col-md-4">
                      <Field
                        id={'proportion'}
                        name={'proportion'}
                        label={'Proportion (%)'}
                        format={'n0'}
                        component={FormNumericTextBox}
                        optional={true}
                        wrapperStyle={{
                          minWidth: '10rem',
                        }} />
                    </div>
                  </div>
                  <FormFooterWithAccess
                    selectedRow={props.selectedRow}
                    formRenderProps={formRenderProps}
                    delete={() => {
                      setDeleteModalVisible(true);
                    }}
                  />
                </fieldset>
              </FormElement>
            )}
          />
        }
      />
      {deleteModalVisible && (
        <ConfirmationModal
          text={`Supprimer cette date en vigueur ?`}
          onClose={() => {
            setDeleteModalVisible(false);
          }}
          onConfirm={() => {
            setDeleteModalVisible(false);
            props.toggleDialog();
            props.remove();
          }}
        />
      )}
    </div>
  );
}

CreateDateModal.propTypes = {
  create: PropTypes.func,
  message: PropTypes.shape({
    ann_seq: PropTypes.any,
    media_cd: PropTypes.any,
    nbrSemaine: PropTypes.any,
  }),
  remove: PropTypes.func,
  selectedRow: PropTypes.shape({
    annv_dt_deb: PropTypes.any,
    annv_dt_fin: PropTypes.any,
    annv_hre_deb: PropTypes.any,
    annv_hre_fin: PropTypes.any,
    annv_proportion: PropTypes.any,
    camp_seq: PropTypes.any,
    nb_sem: PropTypes.any,
    rid: PropTypes.any,
    titre: PropTypes.any,
    camp_num: PropTypes.any
  }),
  toggleDialog: PropTypes.func,
};
